<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="list-title">
        <span class="p-m-0">Cấu hình loại đơn vị</span>
        <span class="p-input-icon-left">
          <Button
           :label="'Tạo mới'"
            type="button"
            v-on:click="onActionClicked({action: {name: 'add', label: 'Tạo mới'}, key: 'add'})"
          > </Button>
        </span>
      </div>
      <BaseCommon v-if="dataModel"
        :key="componentKey"
        :listData="listData"
        :model="dataModel"
        :filterDefault="filters"
        :actions="getRowActions()"
        v-on:action-click="onActionClicked"
      ></BaseCommon>
      <Popup
        v-if="editDialogKey > 0"
        :key="editDialogKey"
        :show="displayDialog"
        :mode="dialogMode"
        :model="modelEdit"
        :modelName="modelName"
        @refresh="refreshData"
      ></Popup>
      <Dialog
        class="dialog-delete"
        header="Xác nhận"
        :visible.sync="showDeleteDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :showHeader="true"
      >
        Xác nhận xoá
        <template
          #footer
        >
          <Button label="Có" @click="deleteData()" />
          <Button label="Không" class="p-button-danger"  @click="showDeleteDialog = false"/>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../../common'
import Popup from './popup'
export default {
  components: {
    BaseCommon,
    Popup
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      modelName: '',
      componentKey: 0,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      modelEdit: {},
      showDeleteDialog: false
    }
  },
  mounted () {
    this.initParams();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    async initParams() {
      this.filters = {};
      this.modelName = 'setting_unit';
      var variables = {
        where_key: {
          status: {'_in': [0,1] }
        },
        orderBy: {
          created_date: 'desc',
          modified_date: 'desc'
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listData = list;
      this.componentKey++;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', label: 'Tạo mới'};
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.edit = { name: 'edit', icon: 'pencil', key: 'id'}
        //  buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path})
          } else  {
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30))
          }
          break;
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.modelEdit = data.data;
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30));
          }
          break;
        case 'delete':
          this.modelEdit = data.data;
          this.showDeleteDialog = true
          break;
      }
      
    },
    refreshData(){
      this.initParams();
    },
    async deleteData() {
      this.showDeleteDialog = false
      var params = {
        'status': 2
      }
      params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
      await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelEdit.id }}})});
      this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xoá dữ liệu thành công', life: 3000 })
      this.initParams();
    }
  }
}
</script>
<style lang="scss">
</style>